import type { TranslationKey } from '@shared/constants/translations';

export const TRANSLATE_MAPPING: Record<string, TranslationKey> = {
  PRICE_LEVEL_LOW: 'hd_price_range_low_title',
  PRICE_LEVEL_TYPICAL: 'hd_price_range_typical_title',
  PRICE_LEVEL_HIGH: 'hd_price_range_higher_title',
};

export const TRANSLATE_NEW_MAPPING: Record<string, TranslationKey> = {
  PRICE_LEVEL_LOW: 'hd_price_range_low_enhanced_title',
  PRICE_LEVEL_TYPICAL: 'hd_price_range_typical_enhanced_title',
  PRICE_LEVEL_HIGH: 'hd_price_range_higher_enhanced_title',
};
